import {Button} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {getApplicationLeadButtonText} from "../../utils/lead/get_application_lead_button_text";
import {ApplicationFormPromotionInfo} from "./ApplicationFormPromotionInfo";

interface IProps {
    handleClick: () => void;
    shouldShowPrice: boolean;
    isProperty?: boolean;
    price?: number | null;
    infoPlacement?: "top" | "bottom";
    vendorId?: number;
}

export const ApplicationFormBoxDefaultRender = (props: IProps) => {
    const {handleClick} = props;

    const buttonText = getApplicationLeadButtonText({
        isPriceHidden: !props.shouldShowPrice,
        isProperty: props.isProperty,
        propertyPrice: props.price
    });

    return (
        <>
            <ApplicationFormPromotionInfo />

            <Button
                variant="filled_primary"
                type="button"
                size="medium"
                onClick={handleClick}
                fullWidth
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_DEVELOPER_BOX}
            >
                {buttonText}
            </Button>
        </>
    );
};
import {Button} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {getApplicationLeadButtonText} from "../../utils/lead/get_application_lead_button_text";
import {ApplicationFormPromotionInfo} from "./ApplicationFormPromotionInfo";

interface IProps {
    handleClick: () => void;
    shouldShowPrice: boolean;
    isProperty?: boolean;
    price?: number | null;
    infoPlacement?: "top" | "bottom";
    vendorId?: number;
}

export const ApplicationFormBoxDefaultRender = (props: IProps) => {
    const {handleClick} = props;

    const buttonText = getApplicationLeadButtonText({
        isPriceHidden: !props.shouldShowPrice,
        isProperty: props.isProperty,
        propertyPrice: props.price
    });

    return (
        <>
            <ApplicationFormPromotionInfo />

            <Button
                variant="filled_primary"
                type="button"
                size="medium"
                onClick={handleClick}
                fullWidth
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_DEVELOPER_BOX}
            >
                {buttonText}
            </Button>
        </>
    );
};
